import React, { useState } from 'react';
import { ChevronDown, Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Badge, BATCH_ESTADOS, fmtDate } from './AdsCreativeParts';
import { TeamCreativeRow, SendBatchButton } from './TeamCreativeRow';
import { adsApprovalsAPI } from '../lib/api';

const CAMP_ESTADOS = { preparacion: 'En preparación', activa: 'Activa', pausada: 'Pausada', finalizada: 'Finalizada' };

const TeamBatch = ({ b, defaultOpen, onEdit, onNew, onChanged }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="rounded-lg border bg-muted/20" data-testid={`team-batch-${b.id}`}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-3 py-2.5 text-left">
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? '' : '-rotate-90'}`} />
        <span className="font-medium flex-1">{b.nombre} <span className="text-xs text-muted-foreground font-normal">· {b.creatives.length} creativo(s){b.sent_at ? ` · enviada el ${fmtDate(b.sent_at)}` : ''}</span></span>
        <Badge map={BATCH_ESTADOS} value={b.estado} testId={`team-batch-status-${b.id}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-2">
          {b.creatives.map((c, i) => <TeamCreativeRow key={c.id} c={c} idx={i} onEdit={onEdit} onChanged={onChanged} />)}
          {!b.sent_at && (
            <div className="flex flex-wrap gap-2 pt-1">
              <Button size="sm" variant="outline" onClick={() => onNew(b.id)} data-testid={`batch-add-creative-${b.id}`}><Plus className="w-3.5 h-3.5 mr-1" />Añadir creativo</Button>
              <SendBatchButton batch={b} onChanged={onChanged} />
              <Button size="sm" variant="ghost" onClick={() => window.confirm('¿Eliminar esta tanda (borrador)?') && adsApprovalsAPI.deleteBatch(b.id).then(onChanged).catch((e) => toast.error(e.message))} data-testid={`batch-delete-${b.id}`}><Trash2 className="w-3.5 h-3.5 text-red-600" /></Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export const TeamCampaignCard = ({ camp, onEdit, onNew, onChanged }) => {
  const [f, setF] = useState(camp);
  const save = (patch) => {
    setF((p) => ({ ...p, ...patch }));
    adsApprovalsAPI.updateCampaign(camp.id, patch).catch((e) => toast.error(e.message));
  };
  const hasDraft = camp.batches.some((b) => !b.sent_at);
  return (
    <div className="rounded-xl border p-4 space-y-3 bg-card" data-testid={`team-campaign-${camp.id}`}>
      <div className="grid sm:grid-cols-6 gap-2">
        <Input className="sm:col-span-3 font-semibold" value={f.nombre} onChange={(e) => setF({ ...f, nombre: e.target.value })} onBlur={() => f.nombre.trim() && f.nombre !== camp.nombre && save({ nombre: f.nombre.trim() })} data-testid={`campaign-name-${camp.id}`} />
        <select value={f.estado} onChange={(e) => save({ estado: e.target.value })} className="sm:col-span-1 h-10 rounded-md border px-2 text-sm bg-background" data-testid={`campaign-status-${camp.id}`}>
          {Object.entries(CAMP_ESTADOS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <Input type="date" value={f.fecha_inicio} onChange={(e) => save({ fecha_inicio: e.target.value })} title="Inicio" data-testid={`campaign-start-${camp.id}`} />
        <Input type="date" value={f.fecha_fin} onChange={(e) => save({ fecha_fin: e.target.value })} title="Fin" data-testid={`campaign-end-${camp.id}`} />
        <Input className="sm:col-span-5" value={f.objetivo} placeholder="Objetivo (leads, ventas, mensajes…)" onChange={(e) => setF({ ...f, objetivo: e.target.value })} onBlur={() => f.objetivo !== camp.objetivo && save({ objetivo: f.objetivo })} data-testid={`campaign-goal-${camp.id}`} />
        <Button variant="ghost" size="sm" onClick={() => window.confirm('¿Eliminar la campaña?') && adsApprovalsAPI.deleteCampaign(camp.id).then(onChanged).catch((e) => toast.error(e.message))} data-testid={`campaign-delete-${camp.id}`}><Trash2 className="w-4 h-4 text-red-600" /></Button>
      </div>
      {camp.batches.map((b, i) => <TeamBatch key={b.id} b={b} defaultOpen={i === 0} onEdit={onEdit} onNew={onNew} onChanged={onChanged} />)}
      {!hasDraft && (
        <Button size="sm" variant="outline" className="border-dashed" onClick={() => adsApprovalsAPI.createBatch(camp.id).then(onChanged).catch((e) => toast.error(e.message))} data-testid={`campaign-new-batch-${camp.id}`}>
          <Plus className="w-3.5 h-3.5 mr-1" />Nueva tanda de creativos
        </Button>
      )}
    </div>
  );
};
